import { fetchCsrfToken } from '../csrf-token-module.js';
import { createCsrfFeedbackDialog } from './feedback-dialog-module.js';

/**
 * Converts a nested object to URLSearchParams using PHP bracket notation
 * (e.g. `cookies[analytics][]=ga`). Only needed when the data contains nested
 * objects or arrays — flat data can use `new URLSearchParams({key: value})`
 * directly.
 *
 * An existing URLSearchParams instance can be passed as a second argument to
 * append to it, e.g., when combining form data with additional nested fields:
 * ```
 *   buildParamsForDoAjaxCall({nested: obj}, new URLSearchParams(new FormData(form)))
 * ```
 *
 * @deprecated
 * @param {Object} data
 * @param {URLSearchParams} [params]
 * @returns {URLSearchParams}
 */
function buildParamsForDoAjaxCall(data, params = new URLSearchParams()) {
  function append(prefix, value) {
    if (value === null || value === undefined) {
      return;
    }
    if (Array.isArray(value)) {
      for (let i = 0; i < value.length; i++) {
        if (typeof value[i] === 'object' && value[i] !== null) {
          append(prefix + '[' + i + ']', value[i]);
        } else {
          params.append(prefix + '[]', value[i]);
        }
      }
    } else if (typeof value === 'object') {
      for (const key in value) {
        append(prefix + '[' + key + ']', value[key]);
      }
    } else {
      params.append(prefix, value);
    }
  }

  if (data && typeof data === 'object') {
    for (const key in data) {
      append(key, data[key]);
    }
  }

  return params;
}

window.buildParamsForDoAjaxCall = buildParamsForDoAjaxCall;

/**
 * Send a POST request with URL-encoded data (application/x-www-form-urlencoded).
 *
 * For flat data, pass a URLSearchParams instance directly:
 * ```
 *   doAjaxCall('/endpoint', new URLSearchParams({key: 'value'}), callback)
 * ```
 *
 * For nested objects/arrays, use buildParamsForDoAjaxCall() to serialize them:
 * ```
 *   doAjaxCall('/endpoint', buildParamsForDoAjaxCall({filter: {color: ['red']}}), callback)
 * ```
 *
 * To serialize an HTML form:
 * ```
 *   doAjaxCall('/endpoint', new URLSearchParams(new FormData(formElement)), callback)
 * ```
 *
 * @deprecated
 * @param {string} url
 * @param {URLSearchParams} data
 * @param {function} callback
 */
window.doAjaxCall = function (url, data, callback) {
  fetch(url, {
    method: 'POST',
    headers: { 'X-CSRF-Token': fetchCsrfToken() },
    body: data,
  })
    .then((response) => {
      if (!response.ok) {
        console.error({ status: response.status, error: response.statusText });
        return;
      }
      return response.json().catch(() => undefined);
    })
    .then((res) => {
      if (!res) {
        return;
      }
      if (res.error_csrf) {
        createCsrfFeedbackDialog(res);
        return;
      }
      callback(res);
    })
    .catch((error) => {
      console.error(error);
    });
};
